import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { Store } from '@ngrx/store'
import { GlobalConstants } from 'src/app/constants/global-constants'
import { AppState } from 'src/app/store/state/app.state'
import {
  SummaryDataTableComponent,
  SummaryDataTableData,
  SummaryDataTableOptions
} from '../../common/summary-data-table/summary-data-table.component'
import { KnowledgeAPIModel, PaginatedAPI } from 'src/app/models/api.model'
import { getKnowledgeSearch } from 'src/app/store/selector/knowledge.selector'
import { Observable } from 'rxjs'
import { KnowledgeService } from 'src/app/services/knowledge/knowledge.service'
import { LOAD_KNOWLEDGE_SUMMARY_DETAILS } from 'src/app/store/action/knowledge.action'
import { KNOWLEDGE_CATEGORY, HEADING } from 'src/app/constants/ui.columns'
import { getTaskCategorySubCategoryMapFromState } from '../../../store/selector/initialize.selector'
import { generateOptionsMapFromSet } from '../../../services/common/common.service'

@Component({
  selector: 'app-knowledge-summary',
  templateUrl: './knowledge-summary.component.html',
  styleUrls: ['./knowledge-summary.component.scss']
})
export class KnowledgeSummaryComponent implements OnInit {
  summaryOptions: SummaryDataTableOptions
  userKnowledgeList$: Observable<PaginatedAPI<KnowledgeAPIModel>>
  summaryData: SummaryDataTableData<KnowledgeAPIModel>
  private taskCategoryMap: Map<string, string>

  queryParamValues = {
    pageNo: 0,
    pageLimit: SummaryDataTableComponent.defaultLimitDropdownValue,
    sortBy: 'heading',
    sortOrder: 'ASC'
  }
  searchRequestBody = {}

  constructor(private route: Router, private appState: Store<AppState>, private knowledgeService: KnowledgeService) {
    this.userKnowledgeList$ = this.appState.select(getKnowledgeSearch())
    this.summaryOptions = {
      downloadable: false,
      additionalButtons: false,
      contentSelectable: false,
      contentSelector: false,
      filterable: true,
      formattedContent: false,
      pageable: true,
      sortable: true
    }
  }
  ngOnInit(): void {
    this.knowledgeService.knowledgeRefresh.subscribe((response) => {
      if (!response) {
        this.userKnowledgeList$ = this.appState.select(getKnowledgeSearch())
        this.loadSummaryData()
      }
    })
    this.appState
      .select(getTaskCategorySubCategoryMapFromState('NA'))
      .subscribe(categorySubCategoryMap => {
        if (categorySubCategoryMap) {
          const categoriesArr = Array.from(categorySubCategoryMap?.keys()).flatMap(array => array)
          const uniqueCategoriesArr = new Set(categoriesArr)
          this.taskCategoryMap = generateOptionsMapFromSet(uniqueCategoriesArr)
        }
      })
    this.summaryData = {
      content$: this.userKnowledgeList$,
      contentSelector: null,
      headers: [HEADING],
      additionalButtons: [],
      currentSearchParams: this.queryParamValues,
      sortCallback: this.sortCallback,
      checkBoxSelectionIds: [],
      searchCallback: this.searchCallback,
      onDropdownLimitChange: this.onDropdownLimitChange
    }
    this.addFiltersWithDynamicOptions()
  }

  searchCallback = (searchParams) => {
    this.searchRequestBody = {
      ...searchParams
    }
    this.loadSummaryData()
  }

  onViewForChange = (event) => {
    this.queryParamValues.pageLimit = event.target.value
    this.loadSummaryData()
  }

  sortCallback = (columnCode, order) => {
    this.queryParamValues.sortBy = columnCode
    this.queryParamValues.sortOrder = order
    this.loadSummaryData()
  }

  private loadSummaryData() {
    let options = {
      queryParams: this.buildQueryParams(),
      searchRequestBody: this.searchRequestBody
    }
    this.appState.dispatch(LOAD_KNOWLEDGE_SUMMARY_DETAILS(options))
  }

  buildQueryParams = (): { key: string; value: string }[] => {
    return [
      {
        key: 'pageNo',
        value: this.queryParamValues.pageNo.toString()
      },
      {
        key: 'limit',
        value: this.queryParamValues.pageLimit.toString()
      },
      {
        key: 'sortBy',
        value: this.queryParamValues.sortBy
      },
      {
        key: 'sortOrder',
        value: this.queryParamValues.sortOrder
      }
    ]
  }

  back() {
    const searchPageLink = `/${GlobalConstants.ROUTING.KNOWLEDGE_HUB}/${GlobalConstants.ROUTING.SEARCH}`
    this.route.navigate([searchPageLink])
  }

  private onDropdownLimitChange = (limit: number) => {
    this.queryParamValues.pageLimit = limit
    this.loadSummaryData()
  }

  addFiltersWithDynamicOptions() {
    // Task Category
    KNOWLEDGE_CATEGORY.filter.getOptionsList = () => {
      return this.taskCategoryMap
    }
    this.summaryData?.headers?.splice(0, 0, KNOWLEDGE_CATEGORY)
  }
}
